import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6734985a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-container" }
const _hoisted_2 = { class: "top-content" }
const _hoisted_3 = { class: "flex-row-centered selection-form" }
const _hoisted_4 = { class: "flex-col-centered input-container" }
const _hoisted_5 = { style: {"display":"grid","grid-template-columns":"max-content"} }
const _hoisted_6 = ["required"]
const _hoisted_7 = ["value"]
const _hoisted_8 = ["title"]
const _hoisted_9 = ["disabled", "title"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 1 }

import { computed, onMounted, inject, ref } from "vue";
import { useContractHireAgreement } from "@/services/composables/ContractHireAgreement";
import { FormatDatePicker } from "@/services/helpers/Helper";
// Data
import IContractRaw from "@/Interfaces/Contract/IContractRaw";
// Table
import Table, { KeyTypeKeys } from "@/components/TablePersistentChecking.vue";
// Misc
import DatePicker from '@/components/common/DatePicker.vue';
import TickCrossBooleanDisplay from "@/components/TickCrossBooleanDisplay.vue";
import MarketSelector from "@/components/MarketSelector.vue";
import { marketSelection } from "@/services/helpers/Helper";
import GroupedInputButton from "@/components/GroupedInputButton.vue";
import FilterOptions from "@/models/enums/ContractHAFilterOptions";
import { loggerKey } from "@/types/ServiceKeys";
import TitledSelection from "@/components/TitledSelection.vue";
import { useRoute } from "vue-router";
import { DisplayableKeys } from "@/services/SorterService";
import IContractPageExpose from "@/Interfaces/components/IContractPageExpose";

export interface IContractProps<T> {
    contractGetAPI: (req)=>Promise<T[]>;
    cols: DisplayableKeys<T>[];
    loadAllByDefault?: boolean;
}
interface IContractPropsInternal<T>{
    contractGetAPI: (req)=>Promise<T[]>;
    hasCheckbox?: boolean;
    cols?: DisplayableKeys<T>[];
    contractName?: string;
    rowFilters?: ((row: T)=>boolean)[];
    rowClickedCallback?: (row: T)=>void;
    rowCheckableFilter?: (row: T)=>boolean;
    loadAllByDefault?: boolean;
    noSingleDownload?: boolean;
    seMarketEnable?: boolean;
    showTableCount?: boolean
}
const fileName = 'ContractHireAgreement.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseContractPage',
  props: {
    contractGetAPI: {},
    hasCheckbox: { type: Boolean, default: undefined },
    cols: { default: ()=>[
        'contractID',
        'customerID',
        'orderID',
        'market',
        'status',
        'hasFileData',
        'initialDate',
        'activationDate',
        'terminationDate'
    ] as DisplayableKeys<T>[] },
    contractName: { default: 'Hire Agreement' },
    rowFilters: {},
    rowClickedCallback: {},
    rowCheckableFilter: { type: Function, default: (row: IContractRaw)=>row.hasFileData },
    loadAllByDefault: { type: Boolean },
    noSingleDownload: { type: Boolean },
    seMarketEnable: { type: Boolean, default: false },
    showTableCount: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;
const log = inject(loggerKey);
const {
    downloadHireAgreementsHoverText,
    searchHoverText,
    dateInputFormatOption,
    isDownloading,
    searchOption,
    contractIDs,
    dateRange,
    updateContracts,
    downloadedContracts,
    contractTable,
    tableError,
    disallowDownload,
    disallowBatchDownload,
    anyChecked,
    getSelected,
    searchContracts,
    clientDownloadHireAgreements,
    viewPdf,
    clearChecked, 
    getTableRef,    
} = useContractHireAgreement<T>(props);
const displayedContracts = computed(()=>
    props.rowFilters?.reduce((arr, filter)=>arr?.filter(filter), downloadedContracts.value) ??
        downloadedContracts.value
);
const _hasCheckbox = computed(()=>props.hasCheckbox ?? !disallowBatchDownload);
__expose({
    downloadedContracts,
    anyChecked,
    getSelected,
    viewPdf,
    clearChecked,
    searchContracts,
    updateContracts,
    marketSelection,
    getTableRef
});
const route = useRoute();
onMounted(() => {
    log?.info(`${fileName} - onMounted()`);
    document.title = route.name?.toString() + ' - UV';
});
function changeMarket(){
    downloadedContracts.value = [];
    contractIDs.value = '';
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(MarketSelector, {
            onChange: changeMarket,
            enableSE: true
          }),
          _renderSlot(_ctx.$slots, "filter-group-extra")
        ]),
        _createElementVNode("form", {
          class: "flex-col-centered input-container",
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_unref(searchContracts) && _unref(searchContracts)(...args)), ["prevent"]))
        }, [
          _createVNode(TitledSelection, {
            for: _unref(searchOption) === 'ID' ? 'contact-id' : 'contract-dates',
            title: `Search ${_ctx.contractName} Contracts:`
          }, {
            default: _withCtx(() => [
              _createVNode(GroupedInputButton, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(contractIDs) ? (contractIDs).value = $event : null)),
                      id: "contact-id",
                      type: "text",
                      placeholder: "Enter Contract ID...",
                      onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_unref(searchContracts) && _unref(searchContracts)(...args)), ["enter"])),
                      style: {"grid-column":"1","grid-row":"1","width":"100%"},
                      required: !_ctx.loadAllByDefault && _unref(searchOption) === 'ID',
                      class: _normalizeClass({ hidden:_unref(searchOption) !== 'ID' })
                    }, null, 42, _hoisted_6), [
                      [_vModelText, _unref(contractIDs)]
                    ]),
                    _createVNode(DatePicker, {
                      uid: "contract-dates",
                      modelValue: _unref(dateRange),
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(dateRange) ? (dateRange).value = $event : null)),
                      range: "",
                      "enable-time-picker": false,
                      format: _unref(FormatDatePicker),
                      "text-input": "",
                      teleport: true,
                      placeholder: "Select Date...",
                      "text-input-options": _unref(dateInputFormatOption),
                      "partial-range": false,
                      style: {"grid-column":"1","grid-row":"1"},
                      required: !_ctx.loadAllByDefault && _unref(searchOption) !== 'ID',
                      class: _normalizeClass({ hidden:_unref(searchOption) === 'ID' })
                    }, null, 8, ["modelValue", "format", "text-input-options", "required", "class"])
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(searchOption) ? (searchOption).value = $event : null)),
                    id: "filter-option"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_unref(FilterOptions)), (op) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: op[0],
                        value: op[0]
                      }, _toDisplayString(op[1]), 9, _hoisted_7))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _unref(searchOption)]
                  ]),
                  _createElementVNode("button", {
                    class: "selection-form-btn",
                    title: _unref(searchHoverText)
                  }, "Search", 8, _hoisted_8)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["for", "title"]),
          _renderSlot(_ctx.$slots, "search-group-extra", {}, () => [
            (!_unref(disallowBatchDownload))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "default-btn",
                  type: "button",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(clientDownloadHireAgreements) && _unref(clientDownloadHireAgreements)(...args))),
                  disabled: _unref(isDownloading),
                  title: _unref(downloadHireAgreementsHoverText)
                }, "Download Agreements", 8, _hoisted_9))
              : _createCommentVNode("", true)
          ])
        ], 32),
        _renderSlot(_ctx.$slots, "header-extra")
      ])
    ]),
    _createVNode(Table, {
      ref_key: "contractTable",
      ref: contractTable,
      Rows: displayedContracts.value,
      Cols: _ctx.cols,
      RowCheckableFilter: _ctx.rowCheckableFilter,
      HasError: !!_unref(tableError),
      HasCheckBox: _hasCheckbox.value,
      SplitColKeys: "",
      ReturnKey: true,
      CheckIncludesNonDisplayed: "",
      ColKey: 'contractID' as KeyTypeKeys<T>,
      RowClickedCallBack: _ctx.rowClickedCallback,
      ShowTableCount: _ctx.showTableCount,
      onCheck: _cache[6] || (_cache[6] = ($event: any) => (anyChecked.value = true)),
      onClear: _cache[7] || (_cache[7] = ($event: any) => (anyChecked.value = false))
    }, _createSlots({
      "validation-header": _withCtx(() => [
        _createTextVNode(" Overall Validation ")
      ]),
      contractID: _withCtx(({value}) => [
        (_ctx.noSingleDownload || _unref(disallowDownload))
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(value.contractID), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_unref(marketSelection)=='GB')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: e=>value.hasFileData?(()=>{_unref(viewPdf)(value.contractID, 'HireAgreement' );e.stopPropagation()})():undefined,
                    class: _normalizeClass({'fake-link':value.hasFileData})
                  }, _toDisplayString(value.contractID), 11, _hoisted_12))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(value.contractID), 1))
            ]))
      ]),
      _: 2
    }, [
      _renderList(_ctx.cols.filter(x=>x!=='contractID'&&x!=='hasFileData'), (col) => {
        return {
          name: `${String(col)}`,
          fn: _withCtx(({value}) => [
            _renderSlot(_ctx.$slots, col, { value: value }, () => [
              _createTextVNode(_toDisplayString(value[col]), 1)
            ])
          ])
        }
      }),
      (!_ctx.noSingleDownload)
        ? {
            name: "hasFileData",
            fn: _withCtx(({value}) => [
              _createVNode(TickCrossBooleanDisplay, {
                value: value.hasFileData
              }, null, 8, ["value"])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["Rows", "Cols", "RowCheckableFilter", "HasError", "HasCheckBox", "RowClickedCallBack", "ShowTableCount"])
  ]))
}
}

})